import { defineComponent as _defineComponent } from 'vue'
import { CSSProperties } from 'vue/types/jsx';
export interface ScheduleProps{
    status?: {
    title: string;
    date: string;
    isOpen: boolean;
    style?: CSSProperties;
  }[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NSchedule',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as {
    status?: {
    title: string;
    date: string;
    isOpen: boolean;
    style?: CSSProperties;
  }[];
};



return { __sfc: true,props }
}

})